<rid-categorise-yes-no
  class="h-dvh"
  [questions]="[
    {
      id: 'q1',
      question: 'Rijmen deze woorden?',
      options: [
        { type: 'WORD', word: 'fruit' },
        { type: 'WORD', word: 'kluit' },
      ],
      answer: 'YES',
    },
  ]"
  (finished)="$router.navigate(['/mechanics/sorting/yes-or-no'])"
/>
